const formatedNumbers = (num: number) => {
  let value = num ? num : 0
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export default formatedNumbers